import React from 'react';
import PropTypes from 'prop-types';

const GraphicsItemRTL = ({ icon, title, description, alt }) => {
  return (
    <>
      <style>{`
        .graphics-item-rtl { display: flex; flex-direction: row-reverse; gap: 12px; align-items: flex-start; minWidth: 250px; margin-right: 10px; }
        .graphics-item-rtl img { width: 38px; height: 38px; object-fit: contain; align-self: flex-start; margin-top: -10px; }
        .graphics-item-rtl .g-title { font-size: 20px; font-weight: 600; color: #111; margin-bottom: 10px; text-align: right; }
        .graphics-item-rtl .g-desc { font-size: 16px; font-weight: 400; color: #858e9d; text-align: right; }
        @media (max-width: 992px) {
          .graphics-item-rtl .g-title { font-size: 18px; }
          .graphics-item-rtl .g-desc { font-size: 15px; }
        }
      `}</style>
      <div className="graphics-item-rtl">
        <img src={icon} alt={alt} />
        <div>
          <div className="g-title">{title}</div>
          <div className="g-desc">{description}</div>
        </div>
      </div>
    </>
  );
};

GraphicsItemRTL.propTypes = {
  icon: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  alt: PropTypes.string
};

export default GraphicsItemRTL;
